module.exports = __webpack_public_path__ + "img/bootstrap4-light-blue.9776a7e6.svg";